import { createTranslations } from '@npco/utils-translations'

export const topBarNavTranslations = createTranslations({
  goToManageBusinessesPage: 'Go to Manage Businesses Page',
  zellerLogo: 'Zeller Logo',
  toggleSidebar: 'Toggle Sidebar',
})
